const isWinOrMac = () => {
  let agent = navigator.userAgent.toLowerCase();
  let isMac = /macintosh|mac os x/i.test(navigator.userAgent);
  let os = "";
  if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
    os = "win32";
  }
  if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
    os = "win64";
  }
  if (isMac) {
    os = "mac";
  }
  return os;
};
const copyText = (text) => {
  const tempInput = document.createElement("textarea");
  tempInput.style.cssText = "position:absolute;top:0;opacity:0;";
  document.body.appendChild(tempInput);
  tempInput.value = text;
  tempInput.select();
  const isCopySuccess = document.execCommand("Copy");
  document.body.removeChild(tempInput);
  return isCopySuccess;
};
export {isWinOrMac, copyText};
export const isEmptyValue = (value) => {
  return value == null || value === "" || value == void 0;
};
export const LOCAL_TOKEN = "Bearer eyJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJnZW5pZS1pYW0tc2VydmljZSIsImFjY291bnRJZCI6IlU1RERDQzUzNjlCRDExNjAwMDFBREQ2OTgiLCJwaG9uZSI6Iis2Mjg2NzU3NTc1Nzc1IiwiZW1haWwiOiJjdWlwaW5nLm1hQGFkdmFuY2UuYWkiLCJhdWQiOiJXRUIiLCJpYXQiOjE2NzgyNTcyODEsImV4cCI6MTY4MDg0OTI4MX0.chyeoedJpbBdsNqkguamuDsdfeFAH5kMNC1nAaCvRgp1QF4GdWBtwmB_oladv2mZTyjwRX2HGULGeoGvUzfbbftiaKMxJzde5DcU0rh2i2GgVS0YSIcGRDIAnqDKxkyWmWuzQwCdyARmUSwXsZudLOLYo7bgubAYvvwbqWjkVJomuYW2h1XGuWymRKnMlxKKpiq_aHjwEkh8Y317OSyFBH8AUKpQik-avnzmD7eQuGxS2ObP5JXcSAfbjzzIg1TUMea4L61b4BBYcS5sw_wMmztNjRMqhAV6cvCMY684hWpKG0ttwSIC2CKJvr42QyBTghYLeJSRx8df2pkQaFELIg";
